import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

export const onSuccessClickFormBasicForm = ({
  dispatch,
  message,
  action,
  id,
  setDataList,
}: {
  dispatch: any;
  message: string;
  action: any;
  id?: string;
  setDataList: (data: any[]) => void;
}) => {
  toast.success(message);
  return dispatch(
    action({
      payload: {
        onSuccess: (message: any, payload: any[]) => {
          return setDataList(payload);
        },
        onError: (message: any) => {},
      },
      id: id,
    })
  );
};
